export default "/kiban/_next/static/images/new-4c5849742de9e79ac0f9b2dff5e3ea39.png";